<template>
  <div class="card">
    <!-- 询比基本信息 -->
    <div class="section">
      <h2 class="project-name">
        {{ order.orderName }}
      </h2>

      <div class="section-title">
        <base-section-title title="询比概况" />
        <slot name="apply"></slot>
      </div>

      <div class="section-content">
        <el-form label-width="120px" class="detail-form">
          <el-form-item label="询比单位：">
            <span>{{ orderInfo.purchaseCompanyName || ' - ' }}</span>
          </el-form-item>
          <el-form-item label="询比编号：">
            <span>{{ order.orderCode || ' - ' }}</span>
          </el-form-item>
          <el-form-item label="项目类型：">
            <span>
              {{ projectTypeDict.translate(order.projectType).label || ' - ' }}
            </span>
          </el-form-item>
          <el-form-item label="报价截止时间：">
            <span>{{ order.offerEndTime | getNormMinuteFilter }}</span>
          </el-form-item>
          <el-form-item label="收货地址：">
            <span>
              {{ address || ' - ' }}
            </span>
          </el-form-item>
        </el-form>
      </div>
    </div>

    <!-- 询比品目信息 -->
    <div class="section">
      <div class="section-title">
        <base-section-title title="品目信息" />
      </div>

      <div class="section-content">
        <purchase-list-supplier
          :item-schema-list="orderInfo.itemSchemaList || []"
          :table-data="materialList"
        />
        <!--<material-table-->
        <!--  is-supplier-->
        <!--  :can-edit="false"-->
        <!--  :table-data="materialList"-->
        <!--/>-->
      </div>
    </div>

    <!-- 对供应商要求 -->
    <div class="section">
      <div class="section-title">
        <base-section-title title="对供应商要求" />
      </div>
      <div class="section-content">
        <el-row>
          <el-col class="detail-content-width">
            <el-form label-width="100px" class="detail-form">
              <el-form-item label="采购类型：">
                <span>
                  {{
                    order.purchaseType !== undefined
                      ? inquiryProcureTypeDict.translate(order.purchaseType)
                        .label
                      : ' - '
                  }}
                </span>
              </el-form-item>
              <el-form-item label="报价要求：">
                <span>{{ quoteRequire || ' - ' }}</span>
              </el-form-item>
              <el-form-item label="平台使用费：">
                <span>{{ strToThousands(order.signUpFee || 0) }} 元</span>
                <money-in-cn class="m-l-10" :money="order.signUpFee" />
              </el-form-item>
              <el-form-item label="保证金：">
                <span>{{ strToThousands(order.guaranteeFee || 0) }} 元</span>
                <money-in-cn class="m-l-10" :money="order.guaranteeFee" />
              </el-form-item>
              <el-form-item label="平台服务费：">
                <el-button
                  v-if="serviceInfo.chargeType === chargeTypeDict.CHARGE.value"
                  type="text"
                  style="padding: 0"
                  @click="openConfigDialog()"
                >
                  费用计算公式
                </el-button>
                <div
                  v-else-if="
                    serviceInfo.chargeType === chargeTypeDict.FREE.value
                  "
                >
                  <span>0 元</span>
                  <money-in-cn money="0" />
                </div>
                <div v-else>-</div>
              </el-form-item>
              <el-form-item label="报价币种：">
                <span>
                  {{
                    currencyTypeDict.translate(order.currencyType).name || '-'
                  }}
                </span>
              </el-form-item>
              <el-form-item
                v-if="order.currencyType === currencyTypeDict.DOLLAR.value"
                label="汇率（美元兑人民币）:"
              >
                <span>{{ order.exchangeRate || '-' }}</span>
              </el-form-item>
              <el-form-item
                v-if="order.isControlPrice === whetherDict.YES.value"
                label="控制总价"
              >
                <span>{{ order.controlPrice }}</span>
                <span class="m-l-4">
                  {{ currencyTypeDict.translate(order.currencyType).label }}
                </span>
                <money-in-cn
                  v-if="order.currencyType === currencyTypeDict.YUAN.value"
                  :money="order.controlPrice"
                />
              </el-form-item>
            </el-form>
          </el-col>
        </el-row>
      </div>
    </div>

    <!-- 备注说明内容 -->
    <div class="section">
      <div class="section-title">
        <base-section-title title="备注说明" />
      </div>
      <div class="section-content">
        <el-row>
          <el-col :xs="24" :sm="24" :md="20" :lg="14" :xl="10">
            <el-form label-width="120px" class="detail-form">
              <span>{{ order.remarks || ' - ' }}</span>
            </el-form>
          </el-col>
        </el-row>
      </div>
    </div>

    <!-- 询比公告 -->
    <div class="section">
      <div class="section-title">
        <base-section-title
          :title="
            order.inquiryType === inquiryWayDict.PUBLIC_INQUIRY.value
              ? '公告内容'
              : '邀请函'
          "
        />
      </div>
      <div class="section-content notice-content">
        <h4>{{ order.noticeTitle }}</h4>
        <u-editor disabled :value="order.noticeContent" />
      </div>
    </div>

    <!----计算公式详情--->
    <charge-config-dialog
      ref="chargeConfigDialog"
      :config-obj="{
        configId: serviceInfo.configId,
        templateId: serviceInfo.templateId
      }"
    />
  </div>
</template>

<script>
// 组件
import BaseSectionTitle from '@/components/common/BaseSectionTitle'
import UEditor from '@/components/common/UEditor/index.vue'
import PurchaseListSupplier from '@/components/common/PurchaseListComponent/PurchaseListSupplier'
import MoneyInCn from '@/components/common/MoneyInCn'
import ChargeConfigDialog from '@/components/common/ChargeConfigDialog'

// 数据字典
import {
  inquiryProcureTypeDict,
  inquiryWayDict
} from '@/dictionary/project/inquiry'
import {
  projectTypeDict,
  currencyTypeDict,
  whetherDict
} from '@/dictionary/project/common'
import { costSubjectDict, chargeTypeDict } from '@/dictionary/company'

// 工具方法
import { strToThousands } from '@/utils/utils'

export default {
  name: 'SupplierInquiryInfo',

  components: {
    BaseSectionTitle,
    UEditor,
    MoneyInCn,
    ChargeConfigDialog,
    PurchaseListSupplier
  },

  props: {
    // 询比单信息
    orderInfo: {
      type: Object,
      default: () => {}
    },

    // 询比单信息
    order: {
      type: Object,
      default: () => {}
    },

    // 品目列表
    materialList: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      inquiryProcureTypeDict, // 采购类型字典
      inquiryWayDict,
      projectTypeDict,
      chargeTypeDict,
      currencyTypeDict,
      whetherDict
    }
  },

  computed: {
    address() {
      if (this.order.address) {
        const {
          receivingCountry,
          receivingProvince,
          receivingCity,
          receivingArea
        } = this.order.address
        if (receivingProvince && receivingCountry === '中国') {
          return `${receivingProvince} / ${receivingCity} / ${receivingArea}`
        } else if (receivingCountry) {
          return receivingCountry
        } else {
          return ' - '
        }
      } else {
        return ' - '
      }
    },

    // 报价要求
    quoteRequire() {
      const resultArray = []
      if (JSON.stringify(this.order) !== '{}') {
        if (this.order.offerRequireTax) resultArray.push('报价含税')
        if (this.order.offerAllowPart) resultArray.push('允许对部分品目报价')
      }
      return resultArray.join('、')
    },

    serviceInfo() {
      const obj =
        (this.orderInfo.chargeList || []).find(
          m => m.costSubject === costSubjectDict.SERVICE_FEE.value
        ) || {}
      return obj
    }
  },

  methods: {
    strToThousands,

    /**
     * 打开平台服务费配置
     */
    openConfigDialog() {
      this.$refs.chargeConfigDialog.open()
    }
  }
}
</script>

<style lang="scss" scoped>
.file-form {
  margin-top: pixel-to-rem($n: 30);
}

.project-name {
  text-align: center;
  font-size: pixel-to-rem($n: 26);
  @include text-bold;
  line-height: 1.5;
  padding: pixel-to-rem(20);
  padding-top: 0;
  border-bottom: 1px solid $border-color;
  margin-bottom: pixel-to-rem($n: 20);
}

// 公告内容样式
.notice-content {
  h4 {
    font-size: pixel-to-rem($n: 20);
  }
}
</style>
